import { render, staticRenderFns } from "./report-hub-banner.vue?vue&type=template&id=3d67ec02"
import script from "./report-hub-banner.vue?vue&type=script&lang=js"
export * from "./report-hub-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d67ec02')) {
      api.createRecord('3d67ec02', component.options)
    } else {
      api.reload('3d67ec02', component.options)
    }
    module.hot.accept("./report-hub-banner.vue?vue&type=template&id=3d67ec02", function () {
      api.rerender('3d67ec02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/report-hub-banner.vue"
export default component.exports